// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { AddressDTO } from '../models';
import { CreateAddressWithOrgDTO } from '../models';
import { ExternalAddressDTO } from '../models';
import { UpdateAddressDTO } from '../models';
/**
 * AddressesApi - axios parameter creator
 * @export
 */
export const AddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create address
         * @param {CreateAddressWithOrgDTO} createAddressWithOrgDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress(createAddressWithOrgDTO: CreateAddressWithOrgDTO, options: any = {}): RequestArgs {
            // verify required parameter 'createAddressWithOrgDTO' is not null or undefined
            if (createAddressWithOrgDTO === null || createAddressWithOrgDTO === undefined) {
                throw new RequiredError('createAddressWithOrgDTO','Required parameter createAddressWithOrgDTO was null or undefined when calling createAddress.');
            }
            const localVarPath = `/v2/addresses`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateAddressWithOrgDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createAddressWithOrgDTO !== undefined ? createAddressWithOrgDTO : {}) : (createAddressWithOrgDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Address By Id
         * @param {string} id Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAddressById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAddressById.');
            }
            const localVarPath = `/v2/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Search addresses by postcode
         * @param {string} postcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAddressesByPostcode(postcode: string, options: any = {}): RequestArgs {
            // verify required parameter 'postcode' is not null or undefined
            if (postcode === null || postcode === undefined) {
                throw new RequiredError('postcode','Required parameter postcode was null or undefined when calling searchAddressesByPostcode.');
            }
            const localVarPath = `/v2/addresses/lookup`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (postcode !== undefined) {
                localVarQueryParameter['postcode'] = postcode;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Address By Id
         * @param {string} id Address id
         * @param {UpdateAddressDTO} updateAddressDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressById(id: string, updateAddressDTO: UpdateAddressDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateAddressById.');
            }
            // verify required parameter 'updateAddressDTO' is not null or undefined
            if (updateAddressDTO === null || updateAddressDTO === undefined) {
                throw new RequiredError('updateAddressDTO','Required parameter updateAddressDTO was null or undefined when calling updateAddressById.');
            }
            const localVarPath = `/v2/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateAddressDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAddressDTO !== undefined ? updateAddressDTO : {}) : (updateAddressDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressesApi - functional programming interface
 * @export
 */
export const AddressesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create address
         * @param {CreateAddressWithOrgDTO} createAddressWithOrgDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress(createAddressWithOrgDTO: CreateAddressWithOrgDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDTO> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).createAddress(createAddressWithOrgDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get Address By Id
         * @param {string} id Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAddressById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).findAddressById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search addresses by postcode
         * @param {string} postcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAddressesByPostcode(postcode: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalAddressDTO>> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).searchAddressesByPostcode(postcode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update Address By Id
         * @param {string} id Address id
         * @param {UpdateAddressDTO} updateAddressDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressById(id: string, updateAddressDTO: UpdateAddressDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).updateAddressById(id, updateAddressDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AddressesApi - factory interface
 * @export
 */
export const AddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create address
         * @param {CreateAddressWithOrgDTO} createAddressWithOrgDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddress(createAddressWithOrgDTO: CreateAddressWithOrgDTO, options?: any) {
            return AddressesApiFp(configuration).createAddress(createAddressWithOrgDTO, options)(axios, basePath);
        },
        /**
         * Get Address By Id
         * @param {string} id Address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAddressById(id: string, options?: any) {
            return AddressesApiFp(configuration).findAddressById(id, options)(axios, basePath);
        },
        /**
         * Search addresses by postcode
         * @param {string} postcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAddressesByPostcode(postcode: string, options?: any) {
            return AddressesApiFp(configuration).searchAddressesByPostcode(postcode, options)(axios, basePath);
        },
        /**
         * Update Address By Id
         * @param {string} id Address id
         * @param {UpdateAddressDTO} updateAddressDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAddressById(id: string, updateAddressDTO: UpdateAddressDTO, options?: any) {
            return AddressesApiFp(configuration).updateAddressById(id, updateAddressDTO, options)(axios, basePath);
        },
    };
};

/**
 * AddressesApi - interface
 * @export
 * @interface AddressesApi
 */
export interface AddressesApiInterface {
    /**
     * Create address
     * @param {CreateAddressWithOrgDTO} createAddressWithOrgDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApiInterface
     */
    createAddress(createAddressWithOrgDTO: CreateAddressWithOrgDTO, options?: any): AxiosPromise<AddressDTO>;

    /**
     * Get Address By Id
     * @param {string} id Address id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApiInterface
     */
    findAddressById(id: string, options?: any): AxiosPromise<{}>;

    /**
     * Search addresses by postcode
     * @param {string} postcode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApiInterface
     */
    searchAddressesByPostcode(postcode: string, options?: any): AxiosPromise<Array<ExternalAddressDTO>>;

    /**
     * Update Address By Id
     * @param {string} id Address id
     * @param {UpdateAddressDTO} updateAddressDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApiInterface
     */
    updateAddressById(id: string, updateAddressDTO: UpdateAddressDTO, options?: any): AxiosPromise<{}>;

}

/**
 * AddressesApi - object-oriented interface
 * @export
 * @class AddressesApi
 * @extends {BaseAPI}
 */
export class AddressesApi extends BaseAPI implements AddressesApiInterface {
    /**
     * Create address
     * @param {CreateAddressWithOrgDTO} createAddressWithOrgDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public createAddress(createAddressWithOrgDTO: CreateAddressWithOrgDTO, options?: any) {
        return AddressesApiFp(this.configuration).createAddress(createAddressWithOrgDTO, options)(this.axios, this.basePath);
    }

    /**
     * Get Address By Id
     * @param {string} id Address id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public findAddressById(id: string, options?: any) {
        return AddressesApiFp(this.configuration).findAddressById(id, options)(this.axios, this.basePath);
    }

    /**
     * Search addresses by postcode
     * @param {string} postcode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public searchAddressesByPostcode(postcode: string, options?: any) {
        return AddressesApiFp(this.configuration).searchAddressesByPostcode(postcode, options)(this.axios, this.basePath);
    }

    /**
     * Update Address By Id
     * @param {string} id Address id
     * @param {UpdateAddressDTO} updateAddressDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public updateAddressById(id: string, updateAddressDTO: UpdateAddressDTO, options?: any) {
        return AddressesApiFp(this.configuration).updateAddressById(id, updateAddressDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for AddressesApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create address
 * @param {CreateAddressWithOrgDTO} createAddressWithOrgDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createAddress(
    createAddressWithOrgDTO: CreateAddressWithOrgDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<AddressDTO> {
    const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).createAddress(createAddressWithOrgDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get Address By Id
 * @param {string} id Address id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findAddressById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).findAddressById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Search addresses by postcode
 * @param {string} postcode 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchAddressesByPostcode(
    postcode: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<ExternalAddressDTO>> {
    const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).searchAddressesByPostcode(postcode, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update Address By Id
 * @param {string} id Address id
 * @param {UpdateAddressDTO} updateAddressDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateAddressById(
    id: string,
    updateAddressDTO: UpdateAddressDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).updateAddressById(id, updateAddressDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

